import Table from '@/utils/table'
import Form from '@utils/form'
import Dialog from '../dialog'
import DialogForm from './components/dialog-form.vue'
import DialogTable from './components/dialog-table.vue'

type OType = 'default' | 'primary' | 'success' | 'warning' | 'danger' | 'info'
interface Operat {
  event: string;
  label: string | ((row: any, index: number) => string);
  type?: OType | ((row: any, index: number) => OType);
  handle?: (row: any, index: number) => void;
  show?: boolean | ((row: any, index: number) => boolean);
  disabled?: boolean | ((row: any, index: number) => boolean);
}

class Operation {
  public operation: Operat[] = []
  public _width = 130

  private _list: any = null
  private _prefix = ''
  private _operation: Operat = { event: '', label: '' }
  private _operationMap: Map<string, Operat> = new Map()

  constructor(operation: Operat[] | string = '') {
    if (typeof operation === 'string') {
      this._prefix = operation
    }
    this.operation = typeof operation === 'string' ? [] : [...operation]
    this._operation = this.operation[this.operation.length - 1]
    this.operation.forEach(item => {
      this._operationMap.set(item.event, item)
    })
  }

  injectList(list: any) {
    this._list = list
  }

  private addOperationMap() {
    if (!this._operation) return
    this._operationMap.set(this._operation.event, this._operation)
  }

  width(width: number) {
    this._width = width
    return this
  }

  add(event: string, label?: string) {
    if (!event) return this
    label = label || event
    this._operation = { event, label: '', type: 'primary' }
    this.operation.push(this._operation)
    this.label(label)
    this.addOperationMap()
    return this
  }

  label(label: string | ((row: any, index: number) => string)) {
    if (typeof label === 'string') {
      this._operation.label = this._prefix && label.indexOf('.') === -1 ? `${this._prefix}.${label}` : label
    } else {
      this._operation.label = label
    }
    return this
  }

  type(type: OType | ((row: any, index: number) => OType)) {
    this._operation.type = type
    return this
  }

  show(show: boolean | ((row: any, index: number) => boolean)) {
    this._operation.show = show
    return this
  }

  handle(handle: (row: any, index: number) => void) {
    this._operation.handle = handle
    return this
  }

  disabled(disabled: boolean | ((row: any, index: number) => boolean)) {
    this._operation.disabled = disabled
    return this
  }

  form(form: Form, cb: (vm: any) => any, opt: any = {}, attrs: any = {}) {
    opt = typeof opt === 'string' ? { title: opt } : opt
    const title = opt.title || this._operation.label
    const dialog = new Dialog()
      .title(title)
      .dialog(opt)
      .component(form.tpl(DialogForm))
      .bind('$form', form)
      .validate(async(vm: any) => {
        const valid = await vm.$refs.form.validate()
        return valid
      })

    this._operation.handle = (row: any, index: number) => {
      dialog.open({ attrs: { row, index, ...attrs }}).then(cb.bind(this._list.vm))
    }
    return this
  }

  table(table: Table, cb: (vm: any) => any, opt: any = {}, attrs: any = {}) {
    opt = typeof opt === 'string' ? { title: opt } : opt
    const title = opt.title || this._operation.label
    const dialog = new Dialog()
      .title(title)
      .dialog(opt)
      .component(table.tpl(DialogTable))
      .bind('$table', table)

    this._operation.handle = (row: any, index: number) => {
      dialog.open({ attrs: { row, index, ...attrs }}).then(cb.bind(this._list.vm))
    }
    return this
  }

  // 跳转页面
  to(name: string, params: object | ((data: any) => object) = {}, query: object | ((data: any) => object) = {}) {
    if (!name) return this
    this._operation.handle = (row) => {
      const p = typeof params === 'function' ? params(row) : params
      const q = typeof query === 'function' ? query(row) : query
      this._list.vm.$router.push({ name, params: p, query: q })
    }
    return this
  }
}

export default Operation
